<p-fluid>
    <div class="grid flex mb-5">
        <div class="col-7">
            <h1 class="mt-0 mb-0">Planning Parameters</h1>
        </div>
        <div class="col-2 flex align-items-center">
            <p-select
                class="p-fluid"
                placeholder="Select a manufacturer"
                [showClear]="true"
                [options]="(manufacturers$ | async)?.getManufacturers()"
                [(ngModel)]="selectedManufacturer"
                optionLabel="name"
                (onChange)="manufacturerChanged()"
                (onClear)="manufacturerCleared()"
            ></p-select>
        </div>
        <div class="col-3 flex align-items-center">
            <p-button
                class="p-fluid"
                (click)="createNewPlanningParameter()"
                [disabled]="!canCreatePlanningParameter()"
            ><icon icon="add" />Create new Planning Parameter</p-button>
        </div>
    </div>
</p-fluid>

<div class="grid">
    <div class="col-12">
        @if (planningParameters.length > 0) {
            <p-table [value]="planningParameters" dataKey="id">
                <ng-template #header>
                    <tr>
                        <th>Name</th>
                        <th># Items</th>
                        <th>Created on</th>
                        <th>Actions</th>

                    </tr>
                </ng-template>
                <ng-template #body let-pp>
                    <tr>
                        <td>{{ pp.name }}</td>
                        <td>{{ pp.items.length }}</td>
                        <td>{{ pp.created | date: 'dd.MM.yyyy HH:mm' }}</td>
                        <td><p-button label="Manage items" size="small" (click)="manageItems(pp)" /></td>
                    </tr>
                </ng-template>
            </p-table>
        } @else {
            <span>Select a manufacturer to see its planning parameters.</span>
        }
    </div>
</div>

<p-dialog [modal]="true" [(visible)]="showManageItemsModal">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Manage items for {{ selectedPlanningParameter.name }}
        </span>
    </ng-template>

    <div class="grid">
        <div class="col-12">
            <p-fluid>
                <p-autoComplete
                    #autoComplete
                    [suggestions]="itemsAutocomplete"
                    (completeMethod)="searchItems($event)"
                    appendTo="body"
                    placeholder="Enter item ID or name"
                    [optionLabel]="getItemLabel"
                    (onSelect)="itemSelected($event)"
                />
            </p-fluid>
        </div>
    </div>

    @if (selectedPlanningParameter && currentItems.length > 0) {
        <div class="grid">
            <div class="col-12">
                <p-table [value]="currentItems" dataKey="id">
                    <ng-template #header>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-item>
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.code }}</td>
                            <td><p-button (onClick)="removeItemFromPlanningParameter()" size="small"><icon icon="trash" /></p-button></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    }

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()"/>
        <p-button label="Save" [outlined]="true" severity="success" (click)="saveItems()" />
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="showCreateOrEditPlanningParameterModal">
    <ng-template pTemplate="header">
        <span class="p-dialog-title">
            Create Planning Parameter for {{ selectedManufacturer.name }}
        </span>
    </ng-template>

    <p-fluid>
        <div class="field">
            <label>Name</label>
            <input type="text" pInputText [(ngModel)]="planningParameterName" />
        </div>
    </p-fluid>

    <ng-template #footer>
        <p-button label="Cancel" [text]="true" severity="secondary" (click)="closeModal()"/>
        <p-button label="Save" [disabled]="!this.planningParameterName" [outlined]="true" severity="success" (click)="savePlanningParameter()" />
    </ng-template>
</p-dialog>
